/**
 * @param element Zu untersuchendes HTML-Element
 * @returns Liefert die Höhe des sichtbaren Bereichs eines Elements zurück
 */
export function visibleHeight  (element : HTMLElement) : number {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible portion
    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, windowHeight);

    // Visible height is the difference, ensuring it's not negative
    return Math.max(0, visibleBottom - visibleTop);
  }

  /**
 * @param element Zu untersuchendes HTML-Element
 * @returns Liefert die Höhe des sichtbaren Bereichs eines Elements zurück
 */
  export function visibleWidth(element : HTMLElement) : number {
    const rect = element.getBoundingClientRect();
    const windowWidth = window.innerWidth;

    // Calculate the visible portion
    const visibleLeft = Math.max(rect.left, 0);
    const visibleRight = Math.min(rect.right, windowWidth);

    // Visible width is the difference, ensuring it's not negative
    return Math.max(0, visibleRight - visibleLeft);
}

